import { createAction } from '../../utils/actions';
import { showToast } from '../../incab/common/actions/toastr';

export const AUTH_PASSWORD_RESET = 'AUTH_PASSWORD_RESET';

export const resetPassword = (email, url, hash) => (dispatch, getState, container) => dispatch(
    createAction(
        AUTH_PASSWORD_RESET,
        container().api.auth.resetPassword(email, url, hash)
            .then(() => dispatch(showToast(
                'success',
                `Инструкции по восстановлению пароля отправлены на адрес ${email}`,
                'Отправлено письмо'
            )))
    )
);



// WEBPACK FOOTER //
// ./src/portal/auth/actions.js